import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//

export default {
  components: {},
  data: function data() {
    return {};
  },
  props: {
    imgType: {
      type: String,
      default: 'singleImg'
    },
    height: {
      type: String | Number,
      default: 300
    }
  },
  computed: {
    imgUrl: function imgUrl() {
      var that = this;
      switch (that.imgType) {
        case 'singleImg':
          return require("../../assets/images/icon/img_pic@2x.png");
          break;
        default:
          return '';
          break;
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {},
  updated: function updated() {},
  beforeDestroy: function beforeDestroy() {},
  destroyed: function destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated: function activated() {},
  watch: {}
};